import { features, stats } from '@/mocks/data';

export default function FeaturesSection() {
  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-4xl font-bold font-heading text-foreground-950 mb-3">
            为什么选择 aaa日韩
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            六大核心优势，为您打造极致的日韩内容观看体验
          </p>
        </div>

        {/* Feature Cards */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6 mb-14 md:mb-20">
          {features.map((feature, idx) => (
            <div
              key={idx}
              className="p-5 md:p-6 rounded-lg bg-background-100 border border-background-200/70 transition-all duration-300 hover:-translate-y-1"
            >
              <div className="w-12 h-12 rounded-full bg-primary-100 flex items-center justify-center mb-4">
                <i className={`${feature.icon} text-xl text-primary-600`}></i>
              </div>
              <h3 className="text-base md:text-lg font-semibold text-foreground-950 mb-2">
                {feature.title}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>

        {/* Stats */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6">
          {stats.map((stat, idx) => (
            <div key={idx} className="text-center p-4 md:p-6">
              <div className="text-2xl md:text-4xl font-bold font-heading text-primary-500 mb-1">
                {stat.value}
              </div>
              <div className="text-xs md:text-sm text-foreground-600">
                {stat.label}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}